import { graphql } from '../gql';
import { useQuery } from '@apollo/client';

export const GET_SUBMISSION_POLICIES_DOCUMENT = graphql(`
  query getSubmissionPoliciesDocument($uuid: String) {
    submissions(filters: { nestedFilters: { entityUuid: $uuid } }) {
      pageInfo {
        totalResults
        pageSize
        hasNextPage
      }
      edges {
        cursor
        node {
          uuid
          documentLink
        }
      }
    }
  }
`);

export function useSubmissionPoliciesDocumentQuery({
  entityUuid,
}: {
  entityUuid?: string;
}) {
  const { loading, data, error } = useQuery(GET_SUBMISSION_POLICIES_DOCUMENT, {
    variables: {
      uuid: entityUuid,
    },
  });

  return {
    loading,
    error,
    data,
  };
}
